module.exports = "/_next/static/images/img-room-same-5dd27c9d.png";